export default "__VITE_ASSET__b530b121__"